import { render, staticRenderFns } from "./LogAdmin.vue?vue&type=template&id=1fbd793c&"
import script from "./LogAdmin.vue?vue&type=script&lang=ts&"
export * from "./LogAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports